/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'base/components/standalone/ContactEditorial/theme';

export const ContactEditorialTheme = theme;
